const state = {
	flash: []
}

const mutations = {
	setFlash: (state, flashObj) => {
		state.flash.push(flashObj)
	},
	removeFlash: (state, flashObj) => {
		const index = state.flash.indexOf(flashObj)
		state.flash.splice(index, 1)
	}
}

const actions = {
	setFetchFailedFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			message: 'Error',
			messageDetails: 'Could not load tutorial'
		})
	},

	setPublishFailedFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			message: 'Error',
			messageDetails: 'Could not publish tutorial'
		})
	},

	setDraftFailedFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			message: 'Error',
			messageDetails: 'Could not create tutorial draft'
		})
	},

	setTutorialErrorsFlash: ({dispatch}, error) => {
		Object.keys(error.response.data).forEach(prop => {
			dispatch('setFlash', {
				type: 'error',
				message: 'Error',
				messageDetails: `Tutorial ${prop} ${error.response.data[prop]}`
			})
		})
	},

	setDraftSuccessFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'success',
			message: 'Tutorial draft saved.',
			messageDetails: 'You can access your draft Tutorials from your profile'
		})
	},

	setUploadFailedFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			message: 'Error',
			messageDetails: 'File upload failed!'
		})
	},

	setStepDetailsFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			messageDetails: 'Please write instructions for first step!'
		})
	},

	setRequestFailedFlash: ({dispatch}) => {
		dispatch('setFlash', {
			type: 'error',
			messageDetails: 'Something went wrong. Please refresh the page and retry'
		})
	},

	setFlash: ({commit}, options) => {
		commit('setFlash', options)

		if (!options.persistent) {
			const timeout = options.timeout || 5000
			setTimeout(() => {
				commit('removeFlash', options)
			}, timeout)
		}
	}
}

export default {
	state,
	mutations,
	actions
}
